import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Pain points" className="border-y border-grape/10 bg-white/70" data-id="element-97" data-mp="2lm0vjedevevm">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "35px"
    }} data-id="element-98" data-mp="26xehrh3fmv6i">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-99" data-mp="2bvy2xfa7c2xt">
          Does this sound like you?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-100" data-mp="21zcyav23gtui">
          You know how to hold space for your clients. But after a full caseload, the documentation still has to be
          written: clear, professional, linked to the plan and true to what happened in the room.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-101" data-mp="3idbgfx12otgx">
          It’s not a lack of skill. It’s a lack of a <span className="text-blush" data-id="element-102" data-mp="3nc5xatfhc7ye">proven structure</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-103" data-mp="1yzvl3o3bazx3">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-104" data-mp="1u23sssyr9bsd" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-105" data-mp="1b4aopnceavte">
                {p.emoji}
              </span>
              <div data-id="element-106" data-mp="1k2mp2h32d7z1">
                <h3 className="text-sm font-bold text-plum" data-id="element-107" data-mp="1k236qz9i4hkh">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-108" data-mp="30gcrzkig5q73">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-109" data-mp="2vkxeitocpwb7">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-110" data-mp="1t43nl5ujwkye">
            ✨ If you answered YES, SIGMA SMART™ has the solution.
          </p>
        </div>
      </div>
    </section>;
}